// DS9.1
import React from 'react';
import useDeviationStats from '../../Stats/useDeviationStats';
import DeviationMediaService from '../../utils/DeviationMediaService';
import TierSidebarCardInner from './TierSidebarCardInner';
var CARD_IMAGE_WIDTH = 275;
var CARD_IMAGE_HEIGHT = 155;
/** Displays a tier deviation in a TierSidebarCard.
 *  This is a wrapper that extracts the props needed in TierSidebarCard
 *  from the deviation structure. */
var TierDeviationSidebarCard = function (_a) {
    var tier = _a.tier, className = _a.className, _b = _a.width, width = _b === void 0 ? CARD_IMAGE_WIDTH : _b, _c = _a.height, height = _c === void 0 ? CARD_IMAGE_HEIGHT : _c;
    var author = tier.author, title = tier.title, textContent = tier.textContent, _d = tier.tier, _e = _d === void 0 ? {} : _d, dollarPrice = _e.dollarPrice;
    var subscribers = useDeviationStats(tier).subscribers;
    var thumb = DeviationMediaService.getSmallestThumbThatFullyCovers(tier, width, height);
    return author && dollarPrice ? (React.createElement(TierSidebarCardInner, { className: className, user: author, monthlyPrice: dollarPrice, imageSrc: thumb === null || thumb === void 0 ? void 0 : thumb.src, title: title, subscriberCount: subscribers, description: textContent === null || textContent === void 0 ? void 0 : textContent.excerpt })) : null;
};
TierDeviationSidebarCard.displayName = 'TierDeviationSidebarCard';
export default TierDeviationSidebarCard;
//# sourceMappingURL=TierSidebarCard.js.map